// extracted by mini-css-extract-plugin
export default {"content":"_1tZ4uWus","moreBtnContainer":"_1tySfxGC","moreBtn":"_1Gt8GCb-","animated":"_3SAjP8Or","revealItem":"_30YTujS8"};